//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Media from "@/listing-app/mixins/Media";
import Theme from "@/listing-app/mixins/Theme";
export default {
  name: "Promo",
  mixins: [Media, Theme],
  props: ["promotion", "version"],
  data() {
    return {};
  },
  computed: {
    visible() {
      if (this.promotion) {
        if (this.version == "mobile") {
          if (this.breakpoint == "lg" || this.breakpoint == "xl") {
            return false;
          }
          return true;
        }
        if (this.breakpoint == "lg" || this.breakpoint == "xl") {
          return true;
        }
        return false;
			}
			return false;
    },
    image() {
      if (this.breakpoint == "lg" || this.breakpoint == "xl") {
        return this.promotion.ImageDesktop;
      }
      return this.promotion.ImageMobile;
    },
    alt() {
      if (this.breakpoint == "lg" || this.breakpoint == "xl") {
        return this.promotion.ImageAltDesktop;
      }
      return this.promotion.ImageAltMobile;
    }
  }
};
